import { StoryData } from "../types/story";

const getStoryData = async (id: string): Promise<StoryData | null> => {
  const baseURL = "https://es-stories-apim.azure-api.net/Stories/StoryData/";

  try {
    const response = await fetch(`${baseURL}${id}`, {
      headers: {
        "Content-type": "application/json",
        "ES-Key": process.env.REACT_APP_UK_KEY ?? "",
      },
    });

    const text = await response.text();

    if (!response.ok || !text) {
      return null;
    }

    return JSON.parse(text);
  } catch (error) {
    return null;
  }
};

export default getStoryData;
